import { FC, useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers';
import { getActiveExperiences, getDurations } from '../../../services/teamExperienceService';
import { ExperienceSummary } from '../models/ExperienceSummaryModel';
import { GenericModel } from '../models/GenericModel';
import { useHistory } from 'react-router-dom';
import { formatDateShortIntl2 } from '../../../helpers/FormatDate';
import Pagination from '../../components/Pagination';
import { getMaxPeople } from '../../experienceHostPreview/components/utils';
import { EXPERIENCE_STATUS } from '../models/ExperienceStatus';
import { showErrorAlert } from '../../../helpers/alert';
import { defaultVerticalImage } from '../../../utils/constants';
import { handleImageErrorGray } from '../../../utils/UtilsFiles';
import { formatDurationLabel, formatUsdAmount, pickDurationName } from '../../../utils/dateValidations';

interface PropsSectionPreOrganized {
}

const SectionPreOrganized: FC<PropsSectionPreOrganized> = ({  }) => {
    const [durations, setDurations] = useState<GenericModel>([]);
    const [paginationData, setPaginationData] = useState<any>(null);
    const [listExperiences, setListExperiences] = useState<ExperienceSummary[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const limit = 5;
    const history = useHistory()

    useEffect(() => {
        const fetchData = async () => {
            const duration = await getDurations();
            setDurations(duration.results)
            const experiences = await getActiveExperiences({ limit, offset: 0, status: `${EXPERIENCE_STATUS.DRAFT}` });
            setPaginationData(experiences);
            setListExperiences(experiences.results);
            setCurrentPage(1);
            setIsLoading(false);
        }
        fetchData();
    },[])

    const totalPages = paginationData
        ? Math.ceil(paginationData.count / limit)
        : 1;

    const handlePageChange = async (page: number) => {
        const offset = (page - 1) * limit;
        const experiences = await getActiveExperiences({ limit, offset, status: `${EXPERIENCE_STATUS.DRAFT}` });
        setPaginationData(experiences);
        setListExperiences(experiences.results);
        setCurrentPage(page);
    };

    const goto = (route:string) => {
        history.push(route)
    }

    return (
        <div className="tap-host-secction-experiences-past-wrapper">
            <div className="tap-host-secction-experiences-past-title">
                select pre-organized  experience to lead
            </div>

            <div className="tap-host-info-box" style={{minWidth: 738}}>
                <div className="tap-host-info-text">
                    have an idea? <a href='#' onClick={()=>showErrorAlert({title:'',message:'coming soon'})} className="tap-host-link">Suggest Experience</a>
                </div>
            </div>
            <div className={`tap-host-secction-experiences-past-list ${isLoading ? '' : 'd-none'}`}>
                <div className='loader-experience'></div>
            </div>
            <div className="tap-host-secction-experiences-past-list">
                {(listExperiences ?? []).map((exp:ExperienceSummary, index:number) =>
                    (<div key={exp.id ?? index} className="tap-host-secction-experiences-past-card">

                        {/* LEFT IMAGE */}
                        <div className="tap-host-secction-experiences-past-img-wrapper">
                            <img className="tap-host-secction-experiences-past-img" src={exp.coverImage ?? ''} onError={handleImageErrorGray} alt={exp.title}/>

                            <div className="tap-host-secction-experiences-past-img-overlay">
                                <div className="tap-host-secction-experiences-past-img-title">
                                    {exp.title}
                                </div>
                            </div>
                        </div>

                        {/* RIGHT CONTENT */}
                        <div className="tap-host-secction-experiences-past-details">

                            {/* HOSTS */}
                            <div className="tap-host-secction-experiences-lead">
                                <div className="tap-host-secction-experiences-lead__title">NOBILIS</div>
                                <div className="tap-host-secction-experiences-lead__subtitle">Operated by Nobilis partners</div>
                            </div>

                            {/* INFO BOX */}
                            <div className="tap-host-secction-experiences-past-info-box">
                                <div className="tap-host-secction-experiences-past-info-row">
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-location">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_location.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {exp.city !== '' ? exp.city : 'N/A'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-calendar">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_date.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {exp?.dates?.length>0 ? formatDateShortIntl2(exp?.dates[0]?.start) : 'N/A'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-user">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_person.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            Max {getMaxPeople(exp) ?? 'N/A'} Guests
                                        </div>
                                    </div>
                                </div>

                                <div className="tap-host-secction-experiences-past-info-row">
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-dollar">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_usd.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {formatUsdAmount(exp.pricePerGuest) || 'N/A'}&nbsp;/&nbsp;{exp?.priceType === 2 || (exp as any)?.price_type === 2 ? 'Group' : 'Guest'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-clock">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_hour.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {formatDurationLabel(exp.duration, pickDurationName(durations, exp.durationType)) || 'N/A'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item"></div>
                                </div>
                            </div>

                            {/* BOTTOM ACTIONS */}
                            <div className="tap-host-secction-experiences-past-actions justify-content-end">
                                <div className="tap-host-secction-experiences-past-buttons">
                                    <div role='button' onClick={()=>goto(`/experience/detail/${exp.id}`)} className="tap-host-secction-experiences-past-btn-view cursor-pointer">
                                        <span>view</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>)
                )}
            </div>
            {listExperiences.length > 0 && paginationData && (<div className='text-start mt-5'>
                <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            </div>)}
            {listExperiences.length == 0 && (<div className="tap-host-secction-experiences-past-img-title justify-content-start text-dark">
                No experiences available.
            </div>)}
        </div>

    )
}

export { SectionPreOrganized }